const EMAIL_REGEX = /([a-zA-Z0-9._-]{1,18}@([a-zA-Z0-9_-]{1,20}\.)+[a-zA-Z0-9_-]{2,10})/g;
const EMAIL_REPLACER = '***@***.***';
const JWT_REGEX = /eyJraWQi[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*/g;
const JWT_REPLACER = '<TOKEN>';

function initSanitizer() {
  const rules = [];

  function addRule(regex, replacer) {
    rules.push({
      regex,
      replacer,
    });
  }

  addRule(EMAIL_REGEX, EMAIL_REPLACER);
  addRule(JWT_REGEX, JWT_REPLACER);

  function sanitize(text) {
    return rules.reduce((data, rule) => data.replace(rule.regex, rule.replacer), text);
  }

  return sanitize;
}

module.exports = {sanitize: initSanitizer()};